export function Businesses() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Businesses">
        <path
          id="Icon"
          d="M6.33268 4.66667H9.66602M6.33268 7.33333H9.66602M6.33268 10H9.66602M11.9993 14V4.13333C11.9993 3.3866 11.9993 3.01323 11.854 2.72801C11.7262 2.47713 11.5222 2.27316 11.2713 2.14532C10.9861 2 10.6128 2 9.86602 2H6.13268C5.38595 2 5.01258 2 4.72736 2.14532C4.47648 2.27316 4.2725 2.47713 4.14467 2.72801C3.99935 3.01323 3.99935 3.3866 3.99935 4.13333V14M13.3327 14H2.66602"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
